import { createContext } from 'react'
import "../CampusGridSection/CampusGrid.scss"
import { useState } from 'react'
import { CgNotes } from "react-icons/cg";
import { Link } from 'react-router-dom'
import "../../CampusViewMore/CampusViewMore.scss"
export const showContentContext = createContext();

const CampusGrid = ({ content }) => {

    const [showContent, setShowContent] = useState(false)
    const [hideContent, setHideContent] = useState(false)
    let n = (content.name !== "electrol" && content.name !== "quiz") ? 1 : 2;
    let l = (content.name !== "electrol" && content.name !== "quiz") ? 5 : 5;
    let arraylistindex = (content.name === "legal" && 1)

    const slashArray = [];
    for (let i = 0; i < 25; i++) {
        slashArray.push("|")
    }


    const handleShowContent = () => {
        setShowContent(!showContent);
        setHideContent(!hideContent)
    }

    return (
        <>
            <div className='campus-grid-container'>
                <div className='campus-grid-subcontainer'>
                    <div className='campus-grid-subcontainer-slash'>
                        <div className='campus-grid-subcontainer-slash-img'>
                            <img src={content.contentImg} alt="NSSCamp"></img>
                        </div>
                        <ul className='campus-grid-slash-container'>
                            {
                                slashArray.map((slash, index) => {
                                    return <li key={index} >{slash}</li>
                                })
                            }
                        </ul>
                    </div>
                    <div className='campus-grid-subcontainer-para'>
                        <div>
                            {
                                content.para && (
                                    <p>
                                        {content.para}
                                        {
                                            (content.name === "citizenconsumer" || content.name === "nss" || content.name === "antidrug" || content.name === "cultural" || content.name === "ncc" || content.name === "iic" || content.name === "yrc" || content.name === "rrc") && (
                                                content.viewmore &&
                                                (
                                                    <span className='campus-viewmore'>
                                                        <Link onClick={handleShowContent} >{!showContent && "View More"}</Link>
                                                    </span>
                                                )
                                            )
                                        }

                                    </p>
                                )
                            }
                            {
                                content.paraobjective && (
                                    <h2>{content.paraobjective}</h2>
                                )

                            }


                            {
                                content.objectivepoints && content.name !== "reader" && (


                                    content.objectivepoints.map((item, index) => (
                                        <ul

                                            className='objective-list'
                                        >

                                            <li className='objective-list-item' key={index}
                                               > {item}

                                                {content.name === "rotaract" &&
                                                    index === content.objectivepoints.length - 1 &&
                                                    content.viewmore && (
                                                        <span className="campus-viewmore">
                                                            <Link onClick={handleShowContent}>
                                                                {!showContent && "View More"}
                                                            </Link>
                                                        </span>
                                                    )}
                                            </li>
                                        </ul>))

                                )
                            }
                            {content.objectivepoints && content.name === "reader" && (
                                <ul className="objective-list">
                                    {content.objectivepoints.map((item, index) => {
                                        if (index > 2) return null;
                                        return (
                                            <li
                                                className="objective-list-item"
                                                key={index}
                                            >
                                                {item}

                                                {content.name === "reader" &&
                                                    index === content.objectivepoints.length - 3 &&
                                                    content.viewmore && (
                                                        <span className="campus-viewmore">
                                                            <Link onClick={handleShowContent}>
                                                                {!showContent && "View More"}
                                                            </Link>
                                                        </span>
                                                    )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}

                            {
                                content.paramission && (
                                    <h2>{content.paramission}</h2>
                                )

                            }

                            {
                                content.paramissioncontent && (
                                    <p>{content.paramissioncontent}

                                    </p>
                                )
                            }

                            {
                                content.paratitle &&
                                (

                                    <h2>{content.paratitle}</h2>

                                )
                            }

                            {
                                content.paratitlecontents &&


                                (
                                    content.paratitlecontents.map((item, index) => (
                                        index < n && (
                                            <ul className='objective-list'>
                                                <li className='objective-list-item'>

                                                    <b>{item.title}</b>{item.content}


                                                    {
                                                        (content.name === "antiragging" || content.name === "cybercrime" || content.name === "savegreen" || content.name === "electrol" || content.name === "quiz" || content.name === "student" || content.name === "mentor") &&
                                                        content.viewmore && index === content.paratitlecontents.length - l &&
                                                        (
                                                            <span className='campus-viewmore'>
                                                                <Link onClick={handleShowContent} >{!showContent && "View More"}</Link>
                                                            </span>
                                                        )
                                                    }
                                                </li>
                                            </ul>
                                        )
                                    ))
                                )


                            }
                            {
                                content.paracontent1 &&
                                <p className='womencell-content'>{content.paracontent1}

                                </p>
                            }
                            {
                                content.paracontent2 &&
                                <p className='womencell-content'>{content.paracontent2}
                                    {
                                        (content.name === "womencell" || content.name === "yrc") &&
                                        content.viewmore &&
                                        (
                                            <span className='campus-viewmore'>
                                                <Link onClick={handleShowContent} >{!showContent && "View More"}</Link>
                                            </span>
                                        )
                                    }
                                </p>
                            }
                            {
                                content.arrayList && (
                                    <>
                                        {
                                            content.arrayList.map((item, index) =>
                                            (
                                                index < arraylistindex &&
                                                <>
                                                    <h3>{item.title}</h3>
                                                    {
                                                        item.content.map((listitem, listitemindex) => (
                                                            <ul className='objective-list'>
                                                                <li className='antirag-container-content'>
                                                                    {listitem}
                                                                    {
                                                                        (content.viewmore && index === 0 && listitemindex === 1) &&
                                                                        (
                                                                            <span className='campus-viewmore'>
                                                                                <Link onClick={handleShowContent} >{!showContent && "View More"}</Link>
                                                                            </span>
                                                                        )
                                                                    }
                                                                </li>
                                                            </ul>
                                                        ))
                                                    }
                                                </>
                                            )
                                            )
                                        }
                                    </>
                                )
                            }


                        </div>
                    </div>
                </div>
            </div>

            {
                showContent && (
                    <div className='antirag-container' style={{ paddingBottom: content.hover && "0" }}>
                        {
                            content.paracontinue && <p className='antirag-container-content'>{content.paracontinue}</p>
                        }
                        {
                            content.title1 && <h2>{content.title1}</h2>
                        }
                        {
                            content.handbook1 && (
                                <div className="handbook-container">
                                    <span>
                                        <CgNotes
                                            className="handbook-icon"
                                            onClick={() => {
                                                const filePath =
                                                    content.name === "iic"
                                                        ? "/sexualharras.pdf"
                                                        : content.name === "antidrug"
                                                            ? "/antidrug.pdf"
                                                            : null;
                                                if (filePath) window.open(filePath, "_blank");
                                            }}
                                        />
                                    </span>
                                    <Link
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            const filePath =
                                                content.name === "iic"
                                                    ? "/sexualharras.pdf"
                                                    : content.name === "antidrug"
                                                        ? "/antidrug.pdf"
                                                        : null;
                                            if (filePath) window.open(filePath, "_blank");
                                        }}
                                    >
                                        {content.handbook1}
                                    </Link>
                                </div>
                            )
                        }

                        {
                            content.handbook2 && (
                                <div className='handbook-container'><span><CgNotes className='handbook-icon' onClick={() => window.open(content.handbook1 && '/sexualharras.pdf', '_blank')} /></span><Link onClick={() => window.open(content.handbook2 && '/iic.pdf', '_blank')}>{content.handbook2}</Link></div>

                            )
                        }

                        {
                            content.paranext &&
                            <p className='antirag-container-content'>
                                {content.paranext}
                                {
                                    (content.name === "rrc" || content.name === "yrc" || content.name === "cultural" || content.name === "antidrug") && (
                                        content.viewless &&
                                        (
                                            <span className='campus-viewmore'>
                                                <Link onClick={handleShowContent} >{showContent && "View Less"}</Link>
                                            </span>
                                        )
                                    )
                                }
                            </p>
                        }
                        {
                            content.paraonetitle && <h2>{content.paraonetitle}</h2>
                        }

                        {

                            content.paratitlecontents &&

                            (
                                content.paratitlecontents.map((item, index) => (
                                    index >= n && (

                                        <ul className='objective-list'>
                                            <li className='antirag-container-content'>
                                                <b className='antirag-container-content'>{item.title} </b> {item.content}
                                                {
                                                    (content.name === "quiz" || content.name === "student" || content.name === "savegreen") &&
                                                    content.viewless &&
                                                    index === content.paratitlecontents.length - 1 &&
                                                    (
                                                        <span className='campus-viewmore'>
                                                            <Link onClick={handleShowContent} >{showContent && "View Less"}</Link>
                                                        </span>
                                                    )
                                                }
                                            </li>
                                        </ul>

                                    )
                                ))
                            )


                        }


                        {
                            content.paraone && (
                                <p
                                    className='antirag-container-content'
                                >
                                    {content.paraone}
                                    {
                                        (content.name === "womencell" || content.name === "sexualharrasment" || content.name === "electrol" || content.name === "rotaract" || content.name === "mentor" || content.name === "yrc") &&
                                        (
                                            <span className='campus-viewmore'><Link onClick={handleShowContent} >{hideContent && "View Less"}</Link></span>
                                        )
                                    }
                                </p>
                            )
                        }
                        {
                            content.organizer && <h2>{content.organizer}</h2>

                        }
                        {
                            content.organizersData && (
                                content.organizersData.map((item, index) =>
                                (
                                    <>
                                        <h3> {item.pos}</h3>
                                        <p className='antirag-container-content'>{item.name}
                                            {
                                                index === content.organizersData.length - 1 &&
                                                (content.name === "savegreen") &&
                                                content.viewless &&
                                                (
                                                    <span className='campus-viewmore'>
                                                        <Link onClick={handleShowContent} >{showContent && "View Less"}</Link>
                                                    </span>
                                                )
                                            }
                                        </p>
                                    </>

                                )
                                )
                            )
                        }

                        {
                            content.title2 && <h2>{content.title2}</h2>
                        }
                        {
                            content.subtitle2 &&
                            <p className='antirag-container-content'>
                                {content.subtitle2}
                                {
                                    content.name === "cybercrime" &&
                                    (<span className='campus-viewmore'><Link onClick={handleShowContent} >{hideContent && "View Less"}</Link></span>)
                                }
                            </p>
                        }
                        {
                            content.subtitle3 &&
                            <h2>
                                {content.subtitle3}
                            </h2>
                        }
                        {
                            content.subtitlecontent3 &&
                            <p className='antirag-container-content'>
                                {content.subtitlecontent3}
                                {
                                    (content.name === "cybercrime" || content.name === "nss" || content.name === "citizenconsumer") &&
                                    (<span className='campus-viewmore'><Link onClick={handleShowContent} >{hideContent && "View Less"}</Link></span>)
                                }
                            </p>

                        }
                        {
                            content.subtitlecontents &&
                            content.subtitlecontents.map((item, index) => (
                                <ul className='objective-list'>
                                    <li className='antirag-container-content' key={index}>{item}
                                        {index === content.subtitlecontents.length - 1 && content.viewless && (<span className='campus-viewmore'><Link onClick={handleShowContent} >{hideContent && "View Less"}</Link></span>)}</li>
                                </ul>
                            ))
                        }


                        {
                            showContent && (
                                <>
                                    {
                                        content.points &&
                                        content.points.map((item, index) => (
                                            <ul className='objective-list'>
                                                <li
                                                    key={index}
                                                    className='antirag-container-content'
                                                >
                                                    {item}
                                                    {index === content.points.length - 1 && content.viewless && (<span className='campus-viewmore'><Link onClick={handleShowContent} >{hideContent && "View Less"}</Link></span>)}
                                                </li>
                                            </ul>
                                        ))}
                                </>
                            )
                        }
                        {
                            content.arraylistTitle && (
                                <h2 style={{ paddingBottom: "12.5px" }}>{content.arraylistTitle}</h2>
                            )
                        }


                        {
                            content.arrayList && (
                                <>
                                    {
                                        content.arrayList.map((item, index) =>
                                        (
                                            index >= arraylistindex &&
                                            <>
                                                <h3>{item.title}</h3>

                                                {
                                                    item.content.map((listitem, listitemindex) => (
                                                        <ul className='objective-list'>
                                                            <li className='antirag-container-content'>
                                                                {listitem}
                                                                {
                                                                    (content.viewless && index === 5 && listitemindex === 1) &&
                                                                    (
                                                                        <span className='campus-viewmore'>
                                                                            <Link onClick={handleShowContent} >{showContent && "View Less"}</Link>
                                                                        </span>
                                                                    )
                                                                }

                                                            </li>
                                                        </ul>
                                                    ))
                                                }
                                            </>
                                        )
                                        )
                                    }
                                </>
                            )
                        }
                        {
                            content.nccarraylistTitle && (
                                <h2>{content.nccarraylistTitle}</h2>
                            )
                        }

                        {
                            content.nccarrayList && (
                                <>
                                    {
                                        content.nccarrayList.map((item, index) =>
                                        (
                                            <ul className='objective-list'>
                                                <li className='antirag-container-content'>
                                                    <b className='antirag-container-content'>{item.title} </b> {item.content}
                                                    {
                                                        content.name === "ncc" &&
                                                        content.viewless &&
                                                        index === content.nccarrayList.length - 1 &&
                                                        (
                                                            <span className='campus-viewmore'>
                                                                <Link onClick={handleShowContent} >{showContent && "View Less"}</Link>
                                                            </span>
                                                        )
                                                    }
                                                </li>
                                            </ul>

                                        )
                                        )
                                    }
                                </>
                            )
                        }
                        {content.objectivepoints && content.name === "reader" && (
                            <ul className="objective-list">
                                {content.objectivepoints.map((item, index) => {
                                    if (index <= 2) return null;
                                    return (
                                        <li
                                            className="objective-list-item"
                                            key={index}
                                        >
                                            {item}

                                            {content.name === "reader" &&
                                                index === content.objectivepoints.length - 1 &&
                                                content.viewmore && (
                                                    <span className="campus-viewmore">
                                                        <Link onClick={handleShowContent}>
                                                            {showContent && "View Less"}
                                                        </Link>
                                                    </span>
                                                )}
                                        </li>
                                    );
                                })}
                            </ul>
                        )}


                    </div>
                )}


        </>
    )
}

export default CampusGrid